'use strict';

import i18n from 'live/services/i18n';
import localeFiles from './spreadsheets/i18n';

const setLocale = (cb) => {
    let intervalId = setInterval(() => {
        var locale = (Live.settings && Live.settings.locale) ? Live.settings.locale : null;

        if (locale != null) {
            i18n.add(localeFiles[locale]);
            if (typeof cb == 'function') cb();
            clearInterval(intervalId);
        }
    }, 200);
};

const setViewPort = () => {
    const meta = document.createElement('meta');
    meta.name = 'viewport';
    meta.content = 'width=device-width, initial-scale=1';
    document.getElementsByTagName('head')[0].appendChild(meta);
};

const init = (cb) => {
    setViewPort();
    setLocale(cb);
    document.title = "Live Spreadsheets"
};

export default init;
